import { StyleSheet } from 'react-native';
import { $green, $gre, $greish } from '../../generalStyles';

export default StyleSheet.create({
    mainWrapper: {
        backgroundColor: 'white',
        width: '95%',
        borderRadius: 15,
        marginVertical: 15,
        padding: 15
    },
    buttonsWrapper: {
        justifyContent: 'flex-end',
        width: '100%',
        alignItems: 'flex-end'
    },
    loginButton: {
        color: '#7d8d8a',
        marginRight: 10,
        borderColor: $greish,
        borderWidth: 1,
        borderRadius: 5,
        textAlign: 'center',
        width: 'fit-content',
        paddingHorizontal: 15
    },
    loginButtonText: {
        fontSize: 14,
        fontFamily: 'Roboto-Regular'
    },
    joinButton: {
        borderColor: $greish,
        borderWidth: 1,
        borderRadius: 5,
        textAlign: 'center'
    },
    title: {
        marginTop: 20,
        fontSize: 20,
        fontWeight: 'bold',
    },
    topBorder: {
        paddingTop: 15,
        borderTopWidth: 1,
        borderTopColor: '#e7e7e7',
    },
    actionButtonsContainer : {
        justifyContent: 'center'
    },
    actionButton: {
        width: '20%',
        margin: 5
    },
    interestedButton : {
        marginTop: 15
    },
    noThanksButton: {
        backgroundColor: '#fff',
        borderColor: 'lightgrey',
        borderWidth: 1,
    },
    noThanksText: {
        fontSize: 14,
        color: 'lightgrey',
    }

});
